// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__3PaM4","primary":"Button_primary__zYd8r","secondary":"Button_secondary__L-Fve","big":"Button_big__2uIUM","small":"Button_small__3xD3K"};